import React from 'react';
import type { ReactNode } from 'react';
import { Layout, theme } from 'antd';

const { useToken } = theme;
const { Header: AntHeader } = Layout;

export interface HeaderProps {
  headerText?: string;
  headerIcon?: ReactNode;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Header: React.FC<HeaderProps> = ({
  headerText,
  headerIcon,
  leftContent,
  rightContent,
  className = '',
  style = {},
}) => {
  const { token } = useToken();

  // Default left content shows the header icon and text if provided
  const defaultLeftContent =
    headerIcon || headerText ? (
      <h2 className="m-0 fw-bolder d-flex align-items-center">
        {/* {headerIcon && <span className="me-2">{headerIcon}</span>}
        {headerText && <span>{headerText}</span>} */}
      </h2>
    ) : null;

  return (
    <AntHeader
      className={`d-flex align-items-center justify-content-between p-3 ${className}`}
      style={{
        background: token.colorBgContainer,
        height: 'auto',
        lineHeight: 'normal',
        ...style,
      }}
    >
      <div className="d-flex align-items-center">{leftContent ?? defaultLeftContent}</div>

      {rightContent && <div className="d-flex align-items-center">{rightContent}</div>}
    </AntHeader>
  );
};

export default Header;
